import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";

export function AdminFlightRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
 const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  async function fetchRequests() {
    setLoading(true);
    setError(null);
    try {
      const resp = await axios.get("https://backend.ysskytravel.com/api/flights/requests");
      setRequests(resp.data.requests || []);
    } catch (err) {
      setError(err.message || "Failed to load requests");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchRequests();
  }, []);

  async function updateStatus(id, status) {
    await axios.patch(`/api/flights/request/${id}`, { status });
    setRequests((prev) =>
      prev.map((r) => (r.id === id ? { ...r, status } : r))
    );
  }

  function StatusBadge({ status }) {
    const colors = {
      pending: "bg-gray-200 text-gray-700",
      in_progress: "bg-yellow-200 text-yellow-700",
      completed: "bg-green-200 text-green-700",
    };
    return (
      <span
        className={`px-3 py-1 text-xs font-semibold rounded-full ${colors[status]}`}
      >
        {status.replace("_", " ").toUpperCase()}
      </span>
    );
  }

  return (
    <div className="max-w-6xl ">
      <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
        {/* HEADER */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold text-primary">
             Flight Requests
          </h2>
          <button
            onClick={fetchRequests}
            className="px-4 py-2 rounded-xl bg-primary text-white shadow hover:opacity-90"
          >
            Refresh
          </button>
        </div>

        {/* LOADING */}
        {loading && (
          <p className="text-center text-primary font-medium">Loading...</p>
        )}

        {/* ERROR */}
        {error && (
          <p className="text-center text-red-600 font-medium">{error}</p>
        )}

        {/* EMPTY */}
        {!loading && !error && requests.length === 0 && (
          <p className="text-center text-gray-600">No flight requests found.</p>
        )}

        {/* LIST */}
        <div className="space-y-6">
          {requests.map((req) => (
            <motion.div
              key={req.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              className="p-6 rounded-2xl bg-gray-50 border border-gray-200 shadow-sm"
            >
              <div className="flex justify-between items-start gap-4">
                {/* LEFT SIDE DETAILS */}
                <div className="space-y-1">
                  <h4 className="text-lg font-semibold text-gray-900">
                    {req.full_name}
                  </h4>
                  <p className="text-sm text-gray-600">{req.email}</p>

                  <div className="text-sm text-gray-700 mt-2">
                    <strong>Route:</strong>{" "}
                    {req.departure} → {req.destination}
                  </div>

                  <div className="text-sm text-gray-700">
                    <strong>Dates:</strong>{" "}
                    {formatDate(req.departure_date)} → {formatDate(req.return_date) || "One Way"}
                  </div>

                  {req.notes && (
                    <p className="text-sm text-gray-700 mt-2">
                      <strong>Notes: </strong> {req.notes}
                    </p>
                  )}
                </div>

               
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
